var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.32227,
    y: 4.9209,
    width: 48.042,
    height: 48.042,
    rx: 24.021,
    fill: "#F8B003"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.517578,
    y: 0.116699,
    width: 57.6503,
    height: 57.6503,
    rx: 28.8252,
    fill: "#F8B003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9735 38.8245C38.8623 39.3528 38.5425 39.6169 38.0143 39.6169C32.6763 39.6169 28.1168 37.7264 24.3357 33.9453C20.5546 30.1642 18.6641 25.6047 18.6641 20.2667C18.6641 19.7384 18.9282 19.4187 19.4564 19.3075L23.7935 18.3066C24.3218 18.1676 24.6971 18.3622 24.9195 18.8905L26.9213 23.5612C27.1159 24.006 27.0186 24.3953 26.6294 24.7289L24.1272 26.7724C24.8778 28.4127 25.8926 29.8653 27.1715 31.1303C28.4504 32.3953 29.8961 33.4031 31.5086 34.1538L33.5938 31.6516C33.8996 31.2624 34.2888 31.1651 34.7615 31.3597L39.4322 33.3614C39.9326 33.5839 40.1133 33.9592 39.9743 34.4874L38.9735 38.8245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.352,
    height: 22.4196,
    fill: "white",
    transform: "matrix(1 0 0 -1 18.668 40.1519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogo);
export default __webpack_public_path__ + "static/media/callLogo.8bde7256e79ab8d9363fb4e9a6bbcab7.svg";
export { ForwardRef as ReactComponent };